import { COMPANY_NAME } from "../config";

export function TermsPage() {
  return (
    <article className="legal-page">
      <span className="eyebrow">Uso responsable</span>
      <h1>Términos y alcance de la herramienta</h1>
      <p>
        Esta calculadora gratuita de {COMPANY_NAME} produce estimaciones con la
        información capturada y la matriz normativa indicada en cada resultado.
        No constituye representación legal, opinión sobre pruebas, recibo de
        nómina, CFDI, determinación oficial de cuotas, sentencia ni convenio
        ratificado.
      </p>
      <h2>Exactitud condicionada</h2>
      <p>
        Un resultado sólo puede ser tan exacto como los hechos ingresados. La
        variabilidad salarial, prestaciones contractuales, incidencias,
        ausencias, topes, acumulados fiscales, otros empleadores, créditos y
        particularidades del expediente pueden modificarlo. Revisa los supuestos
        y advertencias que acompañan cada cálculo.
      </p>
      <h2>Escenarios litigiosos</h2>
      <p>
        Son valuaciones contingentes, no predicciones. La procedencia de veinte
        días por año, reinstalación, salarios vencidos, intereses, prescripción y
        otras prestaciones depende de la acción ejercida y del caso concreto.
      </p>
      <h2>Uso permitido</h2>
      <p>
        Puedes usar y compartir tus resultados para fines informativos y de
        toma de decisiones. Antes de pagar nómina, firmar o ratificar un
        convenio, presentar una declaración o promover un juicio, valida el caso
        con profesionales y sistemas oficiales.
      </p>
    </article>
  );
}

